import { Flex, Layout } from 'antd';
import { Link } from 'react-router-dom';

const { Header } = Layout;

import NavModule from '../Nav';
import Logo_src from '~/assets/images/logo2.png';

import './index.less';

export default () => {
  return (
    <Header className="zt-header">
      <Flex className="zt-container size-full" gap={8} align="center" justify="space-between">
        <Link className="zt-header-brand" to="/" aria-label="简创AIGC 首页">
          <img className="zt-header-logo" src={Logo_src} alt="简创AIGC" />
          <span className="brand-logo">简创AIGC</span>
        </Link>
        <NavModule />
      </Flex>
    </Header>
  );
};
